module.exports = __webpack_public_path__ + "static/img/foreign_enterprises.94e86b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/foreign_enterprises.png
// module id = BQ27
// module chunks = 1